import React, { ReactElement } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { ClassroomDetailsCreate, ClassroomDetailsEdit } from './ClassroomDetailsLayouts';
import { Organization } from 'types/schema-generated-types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    createContainer: {
      maxWidth: 850
    },
    inputLabel: {
      fontWeight: 600,
      marginBottom: theme.spacing(1)
    },
    input: {
      marginBottom: theme.spacing(3)
    },
    radioLabel: {
      ...theme.typography.body1,
      fontWeight: 600
    },
    radioText: {
      ...theme.typography.subtitle1,
      marginLeft: 0
    },
    addMoreButtonContainer: {
      marginTop: theme.spacing(2),
      display: 'flex',
      justifyContent: 'center'
    },
    danger: {
      color: theme.palette.error.main
    },
    coeducatorContainer: { display: 'flex', margin: '8px 0px' },
    coeducatorNameContainer: { flexGrow: 1, flexBasis: '90%' },
    coeducatorButtonContainer: { flexBasis: '10%', justifyContent: 'flex-end' },
    coeducatorButton: { float: 'right' },
    coeducatorName: { marginTop: '6px' }
  })
);

interface ClassroomDetailsFormProps {
  organizations: Array<Organization>;
  isEdit?: boolean;
}

export interface DetailsClassroomForm {
  [propName: string]: object;
}

const ClassroomDetailsForm = ({
  isEdit = false,
  organizations
}: ClassroomDetailsFormProps): ReactElement | null => {
  const classes = useStyles();

  return isEdit ? (
    <ClassroomDetailsEdit classes={classes} organizations={organizations} />
  ) : (
    <ClassroomDetailsCreate classes={classes} organizations={organizations} />
  );
};

export default ClassroomDetailsForm;
